import GlossaryDsfr from "components/templates/glossaryDsfr/GlossaryDsfr";
import elementsTypes from "utils/elementsTypes";

export default {
  key: "GLOSSARYDSFR",
  label: "Lexique (DSFR)",
  Component: GlossaryDsfr,
  initialContents: [
    {
      key: "glossary",
      type: elementsTypes.GLOSSARY,
      value: "",
      children: [],
    },
  ],
};
